import { makeStyles, Typography, Box } from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import { Rating as RatingStars } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "10px 0 30px 0",
    transistion: "0.3s linear",
  },
  sectionHeading: {
    fontSize: "24px",
    fontWeight: "600",
  },
  cmntsBox: {
    transistion: "0.5s linear",
    marginTop: "10px",
  },
  cmntsItem: {
    color: theme.palette.secondary.light,
    fontSize: "12px",

    // backgroundColor: theme.palette.secondary.dark,
    borderRadius: "10px",
    padding: "10px",
    margin: "2px 0",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    // borderTop: `1px solid ${theme.palette.primary.main}`,
    "&:hover": {
      "& $reportBtn": {
        visibility: "visible",
      },
    },
  },
  userName: {
    color: theme.palette.secondary.dark,
    margin: 0,
  },
  reportBtn: {
    margin: 0,
    padding: 2,
    fontSize: 10,
    visibility: "hidden",
  },
}));

function Reviews(props) {
  const classes = useStyles();
  const [showAll, setShowAll] = useState(false);
  const [limit, setLimit] = useState(2);
  const { currentReviews, bookTitle, rating, user } = props;
  // let comments=[]
  // if(currentReviews){
  //     comments = currentReviews.slice(0, limit)
  // }
  // const handleShow = (state) => {
  //     if(state){
  //         setShowAll(true)
  //         setLimit(currentReviews.length)
  //     } else {
  //         setShowAll(false)
  //         setLimit(2)
  //     }
  // }
  return (
    <div className={classes.root}>
      <h2 className={classes.sectionHeading}>Reviews</h2>
      <RatingStars readOnly value={rating} />
      <div className={classes.cmntsBox}>
        {Boolean(currentReviews.length) ? (
          <div>
            {currentReviews
              .filter((comment) => comment.approved)
              .map((comment) => (
                <Box className={classes.cmntsItem}>
                  <p style={{ margin: 0 }}>{comment.comment}</p>
                  <Box m={0} textAlign="right">
                    {/* <IconButton className={classes.reportBtn} >
                                            <Report  />
                                        </IconButton> */}
                    <p className={classes.userName}>
                      - {comment.customer.name}
                    </p>
                  </Box>
                </Box>
              ))}
            {/* <div style={{ width: "100%", textAlign: "right" }}>
              {showAll ? (
                <Button
                  color="secondary"
                  endIcon={<TiArrowSortedUp />}
                  onClick={() => handleShow(false)}
                >
                  Hide
                </Button>
              ) : (
                <Button
                  color="secondary"
                  endIcon={<TiArrowSortedDown />}
                  onClick={() => handleShow(true)}
                >
                  Show All
                </Button>
              )}
            </div> */}
          </div>
        ) : (
          <div>
            <Typography variant="body2" color="secondary">
              There are no reviews yet.
            </Typography>
            {user?.user?.role === "customer" && (
              <>
                <p>Be the first to review {bookTitle}</p>
                <h5>
                  Your email address will not be published. Required fields are marked.
                </h5>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Reviews;
